'use client';

import {Link} from 'next-view-transitions';
import Image from 'next/image';
import ReviewScore from './components/ReviewScore';

const StartButton = ({className}: {className: string}) => (
  <Link
    href="/objetivos/meditationGoal"
    className={'btn-primary block -ml-1 text-center text-xl cursor-pointer max-w-[380px] ' + className}
    prefetch>
    Comenzar
  </Link>
);

const TextContent = () => (
  <>
    <h1 className="lg:text-4xl lg:text-left text-center text-2xl font-bold lg:mb-8 mb-2">Tu mente merece sanar</h1>
    <p className="lg:text-xl lg:text-left text-center text-lg lg:mb-8">
      Comienza tu camino con <strong>Pura Mente</strong>, la app de bienestar y meditación que ayuda a millones a sanar
      su mente.
    </p>
    <p className="lg:text-lg lg:text-left hidden lg:block text-center text-base font-bold lg:mb-8 mb-2">
      Haz el test y pruébala gratis
    </p>
  </>
);

const LeftContent = () => (
  <div className="lg:flex-1 flex flex-col justify-center items-center">
    <div className="max-w-[480px]">
      <TextContent />
      <StartButton className="hidden lg:block" />
    </div>
  </div>
);

const RightContent = () => {
  const bigCircle = 'lg:w-[70vh] lg:h-[70vh] w-[50vh] h-[50vh]';
  const smallCircle = 'lg:w-[50vh] lg:h-[50vh] w-[40vh] h-[40vh]';
  return (
    <div className="flex-1 flex flex-col justify-center items-center">
      <div className="flex-col justify-center items-center fixed flex w-full h-full -z-10">
        <div className={`absolute ${bigCircle} border-[5px] opacity-20 border-blanco rounded-full`} />
        <div className={`absolute ${smallCircle} border-[5px] opacity-20 border-blanco rounded-full`} />
      </div>
      <Image
        src="/images/home_app_mobile.png"
        alt="app"
        width={1000}
        height={1000}
        className="lg:w-[70vh] lg:h-[70vh] w-[45vh] h-[45vh] object-contain z-10"
      />
      <ReviewScore />
    </div>
  );
};

export default function Home() {
  return (
    <div className="flex h-full lg:flex-row flex-col p-4">
      <Image
        src="/images/home_bg.jpg"
        alt="bg"
        width={1920}
        height={1080}
        className="fixed top-0 left-0 w-full h-full object-cover opacity-25 -z-10"
      />

      <LeftContent />
      <RightContent />
      <p className="lg:hidden block text-center text-base mt-2 mb-1">Haz el test y pruébala gratis</p>
      <StartButton className="lg:hidden self-center block" />
    </div>
  );
}
